import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PageLoader from './ui/PageLoader';

export const ProtectedJudgeRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isJudge, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageLoader message="Checking access…" />;
  }
  if (!isAuthenticated) return <Navigate to="/" state={{ from: location }} replace />;
  if (!isJudge) {
    return (
      <div className="page flex items-center justify-center px-4">
        <div className="max-w-md text-center card p-8">
          <h2 className="heading-section text-red-400 mb-2">Judge access required</h2>
          <p className="text-gray-400 text-sm mb-4">
            Contact the organizer if you should be judging this event.
          </p>
          <Link to="/events" className="btn-secondary btn-md inline-flex">
            Back to Events
          </Link>
        </div>
      </div>
    );
  }
  return <>{children}</>;
};
